import './index.css'; // Or './App.css', whichever file you just edited
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { reloadIfChunkError } from './utils/chunkErrorHandler';

// Belt-and-suspenders net for stale-chunk failures that surface as an
// unhandled promise rejection (a dynamic import() that isn't wrapped in a
// local try/catch) rather than a React render error. ChunkErrorBoundary in
// App.js handles the React.lazy()/Suspense case; this covers everything
// else, app-wide, without needing every call site to know about it.
window.addEventListener('unhandledrejection', (event) => {
  if (reloadIfChunkError(event.reason)) {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
